import { useState, useContext } from "react"
import { Link, useNavigate } from "react-router-dom"
import { UserContext } from "../../../contexts/UserContext"

export function AdminAccountMenu() {
    const [accountMenuDisplay, setAccountMenuDisplay] = useState(false)

    const userDataContext = useContext(UserContext)
    const { user, dispatch } = userDataContext

    const navigate = useNavigate()

    async function handleLogout() {
        setAccountMenuDisplay(!accountMenuDisplay)
        localStorage.removeItem("user2")
        dispatch({ type: "LOGOUT" })
        navigate("/")
    }

    return (
        <div
            onClick={() => setAccountMenuDisplay(!accountMenuDisplay)}
            className={
                `account-icon position-relative d-flex justify-content-end 
                ${accountMenuDisplay ? "on" : "off"}`
            }
            style={
                user && user.profilePicture ? {
                    backgroundImage: "url('" + (user.profilePicture) + "')",
                    
                } : {
                    backgroundImage: !accountMenuDisplay ?
                        "url('/images/user.svg')" : "url('/images/user-hover.svg')",
                }
            }>

            <div className="account-menu p-2 rounded-1" onClick={(e) => e.stopPropagation()}>

                <i
                    className="fa-solid fa-x nav-toggle md-off mb-5"
                    onClick={() => setAccountMenuDisplay(false)}>
                </i>

                <div className="username text-center">
                    {user && (user.firstName + " " + user.lastName)}
                </div>

                <hr className="my-2" />

                <div className="d-flex align-items-center gap-2">
                    <div className="account-link-icon"></div>
                    <Link to="/account" onClick={() => setAccountMenuDisplay(!accountMenuDisplay)}>
                        Manage My Account
                    </Link>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <div className="logout-link-icon"></div>
                    <Link onClick={handleLogout}>Logout</Link>
                </div>

            </div>
        </div>
    )
}